import React, { FunctionComponent } from 'react';
import { THeroCarouselCounterIndicatorProps } from '../types/herocarousel.types';

const HeroCarouselCounterIndicator: FunctionComponent<THeroCarouselCounterIndicatorProps> = ({
  isSelected = false,
  baseClassName = 'controls__counter',
}) => {
  const className = isSelected ? baseClassName + ' ' + baseClassName + '--selected' : baseClassName;
  return <div className={className} />;
};

export default HeroCarouselCounterIndicator;
